<template>
    <div id="home" style="flex-grow: 1;" v-loading.fullscreen.lock="changeLoading">
      <Loading :loading="submitLoading" />
      <div style="background-color: white; margin: 10px 20px">
        <div>
          <!--search area-->
          <el-form :inline="true" class="demo-form-inline" ref="searchForm" :rules="searchRules" :model="searchForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('MANUAL.CLIENT')" class="form-label-field" prop="customerName">
                  <el-input @click="showClientNamePop" readonly v-model="searchForm.customerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="入离时间:" class="form-label-field" style="width:80%;" prop="dateValue">
                  <el-date-picker v-model="searchForm.dateValue" type="daterange" range-separator="至" start-placeholder="入住时间" end-placeholder="离店时间" class="myinput_inner"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="酒店Ids:" prop="hotelId">
                  <el-input v-model="searchForm.hotelId" autocomplete="off" type="textarea" :rows="6" style="padding-left: 18px;" placeholder="酒店ID请用,分隔开"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="warning" class="harpIDbtn" @click="savePreDownLoad">加入房型价格下载列表</el-button>
                  <el-button type="warning" class="harpIDbtn" @click="searchPreDownload">刷新下载列表</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-divider>可下载列表只展示最近7天的数据</el-divider>
          <el-table :data="preDownloadList" v-show="preDownloadList.length > 0" border style="margin-top: 15px;">
            <el-table-column prop="createDate" label="创建时间" align="center">
              <template #default="scope">
                {{ formatDateTimeLocal(scope.row.createDate, "YYYY-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column prop="hotelIds" label="酒店ID" align="center" width="120">
              <template #default="scope">
                <el-popover trigger="hover" placement="top">
                  <p>酒店ID: {{ scope.row.hotelIds }}</p>
                  <template #reference>
                    <div class="name-wrapper">
                      <el-tag size="default">酒店ID列表</el-tag>
                    </div>
                  </template>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="customerID" label="企业Code" align="center"></el-table-column>
            <el-table-column prop="customerName" label="企业名称" align="center"></el-table-column>
            <el-table-column prop="checkInDate" label="入住时间" align="center">
              <template #default="scope">
                {{ formatDateTimeLocal(scope.row.checkInDate, "YYYY-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column prop="checkOutDate" label="离店时间" align="center">
              <template #default="scope">
                {{ formatDateTimeLocal(scope.row.checkOutDate, "YYYY-MM-DD") }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('ORDERLIST.Operation')" fixed="right" width="120"  align="center">
              <template #default="scope">
                <el-button @click="getRoomTypeExcel(scope.row)" type="text" size="small" v-if="scope.row.downloadId > 0">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <ConfirmBoxs
        :centerDialogVisible="confirmFlag"
        :confirmMsg="confirmMsg"
        @setConfirmFlag="setConfirmFlag"
      ></ConfirmBoxs>
      <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
    </div>
  </template>
    
    <script>
  import { savePreDownload,getPreDownloadList,downloadExcelForId } from "@/api/shoppingData";
  import Loading from "@/components/Loading.vue";
  import ConfirmBoxs from "@/components/confirmBoxs.vue";
  import DatePicker from "@/components/DatePicker.vue";
  import { formatDateTime, getFileName } from "@/utils/utils.js";
  import Destination from "@/components/Destination.vue";
  import ClientList from "@/components/ClientList.vue";
  export default {
    name: "HBEHotelRoomTypesData",
    components: {
      DatePicker,
      ConfirmBoxs,
      Loading,
      Destination,
      ClientList
    },
    data() {
      return {
        clientListFlag: false,
        ratePlanDialog:false,
        changeLoading: false,
        confirmMsg: "",
        confirmFlag: false,
        submitLoading: false,
        searchForm: {
          posCode:"",
          customerName: "",
          hotelId: "", //酒店ID
          dateValue: '',
          checkInDate: "",
          checkOutDate: "",
        },
        preDownloadList: [],
        ratePlansData:[],
        traceId: "",
        ratePlanTitle: "",
      };
    },
    mounted() {
      this.searchPreDownload();
    },
    computed: {
      searchRules() {
        return {
          "customerName": [{ required: true, message: this.$t("MANUAL.VALIDATECUSTOMERNAME"), trigger: ["blur", "change"], }],
          "dateValue": [{ required: true, message: "请输入入离时间", trigger: ["blur", "change"], }],
          "hotelId": [{ required: true, message: "请输入酒店ID", trigger: ["blur", "change"], }],
        }
      },
    },
    methods: {
      savePreDownLoad() {
        this.$refs["searchForm"].validate(async (valid) => {
          if (valid) {
            this.searchForm.checkInDate = formatDateTime(this.searchForm.dateValue[0],"YYYY-MM-DD");
            this.searchForm.checkOutDate = formatDateTime(this.searchForm.dateValue[1],"YYYY-MM-DD");
            this.submitLoading = true;
            this.savePreDownLoadPram();// 获取FX动态酒店列表信息hotels/search接口
            this.submitLoading = false;
          }
        });
      },
      savePreDownLoadPram() {
        let params = {
          customerID: this.searchForm.posCode,
          customerName: this.searchForm.customerName,
          hotelIds: this.searchForm.hotelId,
          checkInDate: this.searchForm.checkInDate,
          checkOutDate: this.searchForm.checkOutDate,
        };
        savePreDownload(params)
          .then((res) => {
            if (res.code == 200 && res.data) {
              this.confirmMsg = "加入房型价格下载列表成功";
              this.setConfirmFlag(true);
                Object.assign(this.searchForm, {
                posCode: "",
                customerName: "",
                hotelId: "",
                dateValue: "",
                checkInDate: "",
                checkOutDate: ""
                });
            }
            this.searchPreDownload();
          });
      },
      searchPreDownload() {
        getPreDownloadList()
        .then((res) => {
            this.preDownloadList = res.data || [];
        })
      },
      getRoomTypeExcel(row) {
        let params = {
          params: {
            downLoadId: row.downloadId,
            customerCode: row.customerID,
          },
          responseType: 'blob', // 关键：确保以blob方式接收
        };
        downloadExcelForId(params)
          .then((res) => {
            // 兼容axios返回的res.data
            const blob = res instanceof Blob ? res : res.data ? res.data : new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const downloadLink = document.createElement("a");
            const fileName = getFileName();
            downloadLink.download = fileName + ".xls";
            downloadLink.style.display = "none";
            downloadLink.href = URL.createObjectURL(blob);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          })
          .catch((error) => {
            console.log("导出Excel", error);
          });
      },
      setConfirmFlag(value) {
        this.changeLoading = false;
        this.confirmFlag = value;
      },
      // 弹出客户姓名窗口方法
      showClientNamePop() {
        this.clientListFlag = true;
      },
      setCustomerFlag(value) {
        this.clientListFlag = value;
      },
      //选择客户
      selectClient(item) {
        if (this.searchForm.posCode != item.customerCode) {
          this.searchForm.bookingContactId = '';
        }
        this.searchForm.customerName = item.customerName;
        this.searchForm.posCode = item.customerCode;
       
      },
      formatDateTimeLocal(date, format) {
        return formatDateTime(date, format);
      },
    },
  };
  </script>
    
  <style scoped>
  .loading {
    z-index: 999999;
  }
  .paginationsty {
    float: right;
    margin: 1rem 0;
  }
  .harpIDbtn {
    width: 15rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
  }
  .demo-form-inline{
    margin-left: 6rem;
    padding-top: 2rem
  }
  .title-divider {
    height: 2px;
    margin: 10px 0 0 0;
    background-color: #fc6640;
  }
  ::v-deep .dialog-one .el-dialog__body {
    padding: 0px;
  }
  ::v-deep .el-tabs__item.is-active {
    background: #efc4ba;
    color: #000;
    padding-right: 10px;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fc6640;
  }
  ::v-deep .el-input__inner {
    height: 3rem;
    line-height: 2.7rem;
  }
  ::v-deep .dialog-one .el-dialog__header, ::v-deep .dialog-one .el-tabs__active-bar {
    display: none;
  }
  .search-input {
    margin-left: 10%;
  }
  .search-btn {
    margin: 2% 5%;
  }
  .search-btn button {
    padding: 7px 20px;
    border: 1px solid #fc6640;
    color: #fc6640;
    background: transparent;
    cursor: pointer;
  }
  .select-btn {
    color: #fc6640;
    cursor: pointer;
  }
  .myinput_inner {
    height: 4rem;
  }
  </style>
